export const ResumeDriveLink = "https://drive.google.com/file/d/1rqfVkOaWqfh417sQgW4Zp-VJWvYavbVV/view?usp=sharing";
export const ResumeFileName = "Shatrughan-Kumar-Resume-2.5-Years-Experience.pdf";
export const LinkedLink = "https://www.linkedin.com/in/shatrughan-kumar-32236625a/";
export const GithubLink = "https://github.com/shatrukumar47";
